export default {
	Individual: 1,
	Joint: 2,
	OnBehalfOfIndividual: 3,
	OnBehalfOfOrg: 4
};
